module.exports = __webpack_public_path__ + "img/empty.a0aa66ac.png";